import styled from 'styled-components';
import { DESKTOP_MIN_BREAK, XSPHONE_BREAK } from '#/shared/constants';
import CurrentLocationIconBase from '#/shared/components/GeneratedIcons/trimet/CrosshairsGps';
import PlannerBaseIcon from '#/shared/components/GeneratedIcons/trimet/Planner';
import BaseOmniboxButton from '#/shared/components/OmniboxButton';

export const PromptWrapper = styled.div`
  background-color: ${props =>
    props.isLocationSet || props.userHasFavoriteStops
      ? props.theme.backgroundColor
      : props.theme.inverseBackgroundColor2};
  color: ${props =>
    props.isLocationSet || props.userHasFavoriteStops
      ? props.theme.primaryFontColor
      : props.theme.primaryFontColorReverse};
  background-size: auto 80%;
  flex: 1 0 auto;
  max-width: ${DESKTOP_MIN_BREAK};
  padding: ${props =>
    props.userHasFavoriteStops ? '10px 30px 30px' : '10px 30px 20px'};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    padding-top: ${props => (props.userHasFavoriteStops ? '0' : '10px')};
  }
`;

const ContainerStyle = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  margin: 2em 0;
`;

export const MobileContainer = styled(ContainerStyle)`
  display: flex;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    display: none;
  }
`;

export const Message = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  gap: 1em;
  font-size: 1.1em;
  min-width: 300px;
  max-width: 400px;
  margin: 0 0 1em 0;
`;

export const LoadingMessage = styled(Message)`
  text-align: center;
`;

export const MessageMobile = styled(Message)`
  line-height: 1.25;
  margin-bottom: 18px;
  text-align: center;
  font-weight: 600;
  font-size: 1.4em;
`;

export const DesktopContainer = styled(ContainerStyle)`
  display: none;
  @media (min-width: ${DESKTOP_MIN_BREAK}) {
    display: flex;
  }
`;

export const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 15px 0;
`;

export const WelcomeMessage = styled.span`
  font-size: 1em;
  margin-bottom: 18px;
  @media (min-width: ${XSPHONE_BREAK}) {
    font-size: 1.2em;
  }
`;

export const ErrorMessageContainer = styled(ContainerStyle)``;

export const ButtonWrap = styled.div`
  display: flex;
  align-items: start;
  flex: 1 0 auto;
  width: 300px;
  min-width: 300px;
  max-width: 400px;
  margin: 0 auto;
`;

export const CurrentLocationIcon = styled(CurrentLocationIconBase).attrs(
  props => ({
    height: 20,
    width: 20,
    fill: props.theme.primaryFontColorReverse,
  })
)`
  filter: drop-shadow(${props => props.theme.primaryButtonTextShadow});
  margin-right: 8px;
  min-width: 20px;
`;

export const OrWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em;
  margin: 1rem 0 0 0;
  text-transform: uppercase;
  &::before,
  &::after {
    content: '—';
  }
`;

export const PlannerIcon = styled(PlannerBaseIcon).attrs({
  height: 20,
  width: 20,
})`
  margin: 0 5px 0 0;
  min-width: 20px;
`;

export const OmniboxButton = styled(BaseOmniboxButton)`
  width: 100%;
`;
